import * as yup from "yup";

const specialSkillSchema = yup.object({
    description: yup.string().trim().required("Description is required.")
});

export default specialSkillSchema;
